export default __webpack_public_path__ + "static/media/ding2.91113593.ogg";